/**
 * Phase N — Legal review banner. Renders when site_settings.legal_review_complete = false.
 */
import { useSiteSettings } from "@/lib/siteSettings";

export default function LegalReviewBanner() {
  const settings = useSiteSettings();
  // Show while settings load; hide only when explicitly complete.
  if (settings && settings.legal_review_complete === true) return null;
  return (
    <div className="bg-crimson/10 border-b border-crimson/30 text-crimson" data-testid="legal-review-banner">
      <div className="max-w-5xl mx-auto px-5 py-2 text-[11px] uppercase tracking-[0.22em] font-semibold text-center">
        Legal review pending — draft version
      </div>
    </div>
  );
}
